import { render } from "./HeroAuthDashboardContent.vue?vue&type=template&id=1b1be542&scoped=true"
import script from "./HeroAuthDashboardContent.vue?vue&type=script&lang=js"
export * from "./HeroAuthDashboardContent.vue?vue&type=script&lang=js"

import "./HeroAuthDashboardContent.vue?vue&type=style&index=0&id=1b1be542&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1be542"]])

export default __exports__